import React, { useEffect } from "react";
import { getFestiveFocus, isNavratriDasaraSeason } from "./navratriSeason";
import "./festive-theme.css";

export default function FestiveSiteTheme() {
  const active = isNavratriDasaraSeason();
  const night = active ? getFestiveFocus().day : null;

  useEffect(() => {
    if (!active) return undefined;
    const { body } = document;
    body.classList.add("festive-site");
    body.classList.toggle("festive-site--light", Boolean(night.light));
    body.style.setProperty("--festive-night", night.hex);
    body.style.setProperty("--festive-ink", night.ink);
    return () => {
      body.classList.remove("festive-site", "festive-site--light");
      body.style.removeProperty("--festive-night");
      body.style.removeProperty("--festive-ink");
    };
  }, [active, night]);

  return null;
}
